import { useState, useEffect } from "react";
import NavBar from "../../Nav Bar/NavBar";
import ColoredLogo from "../../assets/ColoredLogo.svg";

const PrivacyPolicy = () => {
  const [styles, setStyles] = useState({
    container: {
      minHeight: "1491px",
      margin: "120px 0px 60px 0px",
    },

    h3: {
      fontSize: "32px",
      fontWeight: "700",
      color: "#000",
      marginBottom: "38px",
    },

    h5: {
      fontSize: "24px",
      fontWeight: "700",
    },

    overviewContainer: {
      paddingBottom: "38px",
    },

    article: {
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "28px",
    },

    span: {
      fontSize: "16px",
      fontWeight: "700",
    },

    p: {
      fontSize: "16px",
      fontWeight: "500",
    },
  });

  useEffect(() => {
    const updateStyles = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth <= 380) {
        setStyles((prevStyles) => ({
          ...prevStyles,
          container: {
            ...prevStyles.container,
            maxHeight: "4103px",
            margin: "132px 16px 86px 16px",
          },
        }));
      } else if (screenWidth <= 440) {
        setStyles((prevStyles) => ({
          ...prevStyles,
          container: {
            ...prevStyles.container,
            maxWidth: "358px",
            minHeight: "2000px",
            margin: "132px 12px 97px 12px",
          },
          h3: {
            ...prevStyles.h3,
            fontSize: "24px",
          },
          h5: {
            ...prevStyles.h5,
            fontSize: "16px",
          },
          overviewContainer: {
            ...prevStyles.overviewContainer,
            paddingBottom: "24px",
          },
          article: {
            ...prevStyles.article,
            fontSize: "14px",
            fontWeight: "500",
          },
        }));
      } else if (screenWidth <= 780) {
        setStyles((prevStyles) => ({
          ...prevStyles,
          container: {
            ...prevStyles.container,
            minHeight: "2000px",
          },
        }));
      } else if (screenWidth <= 930) {
        setStyles((prevStyles) => ({
          ...prevStyles,
          container: {
            ...prevStyles.container,
            height: "1800px",
          },
        }));
      }
    };

    updateStyles();
    window.addEventListener("resize", updateStyles);

    return () => window.removeEventListener("resize", updateStyles);
  }, []);
  return (
    <div>
      <NavBar linkColor="#000000" logo={ColoredLogo} bg="#fff" />
      <div className="container tofSection" style={{ width: "86%" }}>
        <div style={styles.container}>
          <h3 style={styles.h3}>GiftCard8 Privacy Policy</h3>

          <div style={styles.overviewContainer}>
            <h5 style={styles.h5}>Overview</h5>
            <article style={styles.article}>
              Thank you for choosing GiftCard8! We value your privacy and are
              committed to protecting your personal information. This Privacy
              Policy explains how GiftCard8 (called "we" or "Platform")
              collects, uses, stores, and shares your information. This policy
              applies to{" "}
              <a
                href="https://giftcard8.com"
                style={{ textDecoration: "none" }}
              >
                giftcard8.com
              </a>{" "}
              and all applications and services provided by GiftCard8.
            </article>
          </div>

          <div>
            <h5 style={styles.h5}>1. Information We Collect</h5>
            <article style={styles.article}>
              When you use GiftCard8, we may collect the following information:
              Personal information: such as your name, email, phone number,
              payment information and transaction history, for registration,
              authentication, transactions and customer support.
              <br />
              Non-personal information: including device information, browser
              type, operating system, access time, etc., for analyzing access
              trends and improving user experience. <br />
              <br />
            </article>

            <h5 style={styles.h5}>2. Cookies and Tracking Technology</h5>
            <article style={styles.article}>
              We use Cookies and similar technologies to provide personalized
              services, improve platform performance and analyze user behavior.
              Users can disable Cookies through their browsers, but this may
              affect the normal use of the platform.
              <br />
              <br />
            </article>

            <h5 style={styles.h5}>3. How Information is Used</h5>
            <article style={styles.article}>
              We may use the information collected for the following purposes:
              <br />
              Account management: to ensure the security of your account and the
              accuracy of your information.
              <br />
              Platform operation: to enable the normal operation of the platform
              content and functions.
              <br />
              Customer Service: Respond to your requests and solve problems more
              efficiently.
              <br />
              Payment and Transaction Processing: Complete your transactions and
              send notifications.
              <br />
              Improvement and Personalization: Improve platform features and
              content based on user feedback and needs.
              <br />
              <br />
            </article>

            <h5 style={styles.h5}>4. Information Protection</h5>
            <article style={styles.article}>
              GiftCard8 will use strong security measures to protect user
              information. This includes encryption and access control. These
              steps help prevent unauthorized access, disclosure, and changes to
              data.
              <br />
              Our data protection system meets industry standards. We will
              regularly check and update it to address new security threats.
              <br />
              <br />
            </article>

            <h5 style={styles.h5}> 5. Information Sharing</h5>
            <article style={styles.article}>
              GiftCard8 respects user privacy and will never sell, trade or rent
              users' personally identifiable information to others. We will only
              share necessary information with trusted partners in the following
              circumstances:
              <br />
              Service Providers: Partners who provide platform operations,
              payment processing and other functions.
              <br />
              Legal Compliance: When required by law, or to protect our rights
              and user safety.
              <br />
              <br />
            </article>

            <h5 style={styles.h5}>6. Children's Privacy Protection</h5>
            <article style={styles.article}>
              GiftCard8 actively protects children's privacy. We will not
              collect personal information from kids under 13 years old. If we
              find such data, we will immediately take steps to delete the
              relevant information.
              <br />
              <br />
            </article>

            <h5 style={styles.h5}>7. Changes to the Privacy Policy</h5>
            <article style={styles.article}>
              GiftCard8 reserves the right to update this Privacy Policy at any
              time. When we make an update, we will post a notice on the
              Platform and users can view the latest privacy terms. If users
              continue to use the Platform, they accept the latest Privacy
              Policy.
              <br />
              <br />
            </article>

            <h5 style={styles.h5}>8. User Rights</h5>
            <article style={styles.article}>
              Under data protection laws, users can access, correct, and delete
              their personal information. They can also limit how GiftCard8
              processes their data. If necessary, please contact us using the
              contact information below.
              <br />
              <br />
            </article>

            <h5 style={styles.h5}>9. Contact Information</h5>
            <article style={styles.article}>
              If you have questions about this Privacy Policy or need more
              information, please contact us in these ways:
              <br />
              Email: gcard8business@GiftCard8.com
              <br /> WhatsApp: +447704521940
              {/* <br /> Last updated: [November 2024] */}
            </article>

            <br />
            <br />
            <p style={styles.p}>Updated: November 2024</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
